import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import AddFacebookPageForm from './AddFacebookPageForm'
import FormDrawerWrapper from '../../../../../../features/components/FormDrawerWrapper'
import SkeletonSingleSectionForm from '../../../../../../features/components/FormDrawerWrapper/Skeletons/SkeletonSingleSectionForm'

import useManageDrawer from '../../../../../../hooks/formHooks/useManageDrawer'

import { getFacebookPages, clearFacebookPages } from '../../../../../../modules/actions/socialAccounts'
import { facebookPagesWasLoadedSelector } from '../../../../../../modules/selectors/socialAccounts'

import { ACCESSIBLE_SOCIAL_PAGE_ADD_FACEBOOK } from '../../../../../../constants/forms'

const AddFacebookPage = () => {
  const dispatch = useDispatch()

  const facebookPagesWasLoaded = useSelector(facebookPagesWasLoadedSelector)

  const { isFormOpen } = useManageDrawer({
    formName: ACCESSIBLE_SOCIAL_PAGE_ADD_FACEBOOK
  })

  useEffect(() => {
    if (isFormOpen && !facebookPagesWasLoaded) {
      dispatch(getFacebookPages({}, true))
    }
  }, [dispatch, isFormOpen, facebookPagesWasLoaded])

  useEffect(
    () => () => {
      dispatch(clearFacebookPages())
    },
    [dispatch]
  )

  return (
    <FormDrawerWrapper
      formName={ACCESSIBLE_SOCIAL_PAGE_ADD_FACEBOOK}
      openButtonText="Add a Facebook Page"
      title="Add a Facebook page"
      isFormLoading={!facebookPagesWasLoaded}
      SkeletonFormComponent={SkeletonSingleSectionForm}
    >
      <AddFacebookPageForm />
    </FormDrawerWrapper>
  )
}

export default AddFacebookPage
